import { render, staticRenderFns } from "./b4-card-list.vue?vue&type=template&id=0acf61ea&scoped=true"
import script from "./b4-card-list.vue?vue&type=script&lang=js"
export * from "./b4-card-list.vue?vue&type=script&lang=js"
import style0 from "./b4-card-list.vue?vue&type=style&index=0&id=0acf61ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf61ea",
  null
  
)

export default component.exports